import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../../../../components/ui/Button";
import { saveHotInfoTrack, getHotInfoById } from "../../../../../api";
import TitleSubtitle from "../../../../../components/common/TitleSubtitle";
import TextInput from "../../../../../components/ui/TextInput";
import { useTrackCreation } from "../../../../../context/TrackCreationContext";
import { HotInfoCoordinatesProps, RouteParamsWithLanguage } from "../../../../../types/screensTypes";
import stepStyles from "../../createStep.module.css";
import partnerStyles from "./PartnerEdit.module.css";

const HotInfoCoordinates: React.FC<HotInfoCoordinatesProps> = ({ navigateToNext }) => {
    const { trackData } = useTrackCreation();
    const { hotinfoId, language } = useParams<RouteParamsWithLanguage>();
    const [coordinates, setCoordinates] = useState<string>("");
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const handleSaveChanges = async (): Promise<void> => {
        const token = localStorage.getItem("token");
        const trackId = trackData.trackId;

        if (!hotinfoId || !trackId || !token || !language) {
            return;
        }

        if (coordinates.trim() !== "") {
            const [latitude, longitude] = coordinates.split(",");
            if (latitude && longitude) {
                await saveHotInfoTrack({
                    token,
                    trackId,
                    id: hotinfoId,
                    lat: parseFloat(latitude.trim()),
                    lng: parseFloat(longitude.trim()),
                });
                navigateToNext(hotinfoId, language);
            }
        }
    };

    const getHotInfo = async (id: string): Promise<void> => {
        const token = localStorage.getItem("token");
        if (!token || !language) {
            return;
        }
        const hotInfoData = await getHotInfoById({
            token,
            hotinfoId: id,
            language,
        });
        if (hotInfoData && hotInfoData.point) {
            const point = hotInfoData.point;
            setCoordinates(`${point.lat}, ${point.lng}`);
        } else {
            setCoordinates("0.0, 0.0");
        }
    };

    useEffect(() => {
        if (hotinfoId && hotinfoId !== "") {
            getHotInfo(hotinfoId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hotinfoId, language]);

    return (
        <div className={`${stepStyles.editScreen} ${partnerStyles.screen}`}>
            <TitleSubtitle title={t("modifyCoordinatesPartner")} subtitle={""} layout="edit" />
            <div className={partnerStyles.fieldNarrow}>
                <TextInput
                    placeholder={t("enterCoordinatesLatLng")}
                    value={coordinates}
                    size="small"
                    onChange={(e) => setCoordinates(e.target.value)}
                />
            </div>
            <div className={`${stepStyles.stepButton} ${stepStyles.footer}`}>
                <Button
                    variant="primary"
                    shape="pill"
                    className={`${stepStyles.continueBtn} ${partnerStyles.continueBtn}`}
                    label={t("continue")}
                    onClick={handleSaveChanges}
                />
            </div>
        </div>
    );
};

export default HotInfoCoordinates;
